export default __webpack_public_path__ + "static/media/transparent_pega.00a15bb6.png";